import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout } from '@/_containers';

export default function Loading() {
  return (
    <CardContainer>
      <FormLayout>
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
      </FormLayout>
    </CardContainer>
  );
}
